import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

export const QuestionListActionButtonsRowDIV = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  padding: 8px 4px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr fit-content(142px) 1fr;
  gap: 8px;
  height: 62px;
  background: #f5f8ff;
  transition: opacity 0.3s ease-in;

  .Button {
    white-space: nowrap;
    height: 42px;
    font-size: var(--font-size--S);

    &:not(:last-of-type) {
      border-width: 1px;
    }

    @media (min-width: 375px) {
      padding: 0 19px;
    }
  }

  ${MEDIA_QUERIES.S} {
    grid-template-columns: repeat(3, 1fr);
  }

  // Weird stacking breakpoint
  ${MEDIA_QUERIES.M} {
    position: static;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 10px;
    margin-right: var(--spacing--S);
    width: auto;
    height: auto;
    background: transparent;
    margin: 0;
    padding: 0;

    .Button {
      height: auto;
      cursor: pointer;
      padding: 0 10px;
      font-size: var(--font-size--XS);
    }
  }

  @media (min-width: 1020px) {
    padding: 0 var(--spacing--S);
  }
`

export const QuestionListActionButtonsModalDIV = styled.div`
  text-align: center;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--spacing--XS);

    ${MEDIA_QUERIES.S} {
      flex-direction: row;
    }
  }
`
